
import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardMedia from "@material-ui/core/CardMedia";
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';

import Grid from '@material-ui/core/Grid';
import RenderFile from '../RenderFile/RenderFile';
import CircularProgress from '@material-ui/core/CircularProgress';

class UploadDisplay extends React.Component {
  
    DeleteFile = (toDeleteFile) => {
      this.props.DeleteFile(toDeleteFile);
    }
   
    render() {
      const {uploadedFiles, s3Url} = this.props
      return (
        <React.Fragment>
        <Typography  color="textSecondary" gutterBottom>
        {this.props.placeholder != null ? this.props.placeholder : 'Click aquí o arrastre para elegir una o más fotos. (Formato JPG, Máximo 2MB).'}       
        </Typography>
        <Grid container spacing={3} style={{margin:"20px", width:"95%"}}>
          
            {
              (this.props.progress != null ?
                <React.Fragment>
                <CircularProgress variant="static" value={this.props.progress} />
                </React.Fragment>
              : 
          
              uploadedFiles.map((uploadedFile, i) => <RenderFile uploadedFile={uploadedFile} DeleteFile={this.DeleteFile}/>)
              )
          }
        </Grid>
        </React.Fragment>
      )
    }
  }

  export default UploadDisplay;